import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ROUTE_META from "./routeMeta.json";

const SITE = "https://norse3.com";
const DEFAULT_DESC = "norse3 — independent AI governance and oversight. Control what AI can see, say and do, with human oversight and reviewable evidence.";

export { ROUTE_META };

function setMeta(selector, attr, value) {
  const el = document.querySelector(selector);
  if (el) el.setAttribute(attr, value);
}

export function applyMeta(title, description = DEFAULT_DESC, path = window.location.pathname, image = "/og-image.jpg") {
  document.title = title;
  setMeta('meta[name="description"]', "content", description);
  setMeta('meta[property="og:title"]', "content", title);
  setMeta('meta[property="og:description"]', "content", description);
  setMeta('meta[name="twitter:title"]', "content", title);
  setMeta('meta[name="twitter:description"]', "content", description);
  setMeta('meta[property="og:url"]', "content", `${SITE}${path}`);
  setMeta('link[rel="canonical"]', "href", `${SITE}${path}`);
  ["og:image", "og:image:secure_url"].forEach((p) => setMeta(`meta[property="${p}"]`, "content", `${SITE}${image}`));
  setMeta('meta[name="twitter:image"]', "content", `${SITE}${image}`);
}

export function RouteMeta() {
  const { pathname } = useLocation();
  useEffect(() => {
    const meta = ROUTE_META[pathname];
    if (meta) applyMeta(meta.title, meta.description, pathname, meta.image);
  }, [pathname]);
  return null;
}
